export default __webpack_public_path__ + "static/media/pdfteam.a7787329.jpg";